/**
 * Google Ads tracking (tag AW-) et conversion du clic sur le deeplink Appines.
 *
 * Le tag Google Ads est chargé en parallèle de GA4 via le même gtag, uniquement
 * après consentement utilisateur. La conversion est envoyée avec `send_to`
 * ciblant l'action de conversion "CTA - Deeplink Inscription App".
 */

const GOOGLE_ADS_ID = 'AW-792685791';
const DEEPLINK_CONVERSION_SEND_TO = 'AW-792685791/7iZ-COPwrqocEN_Z_fkC';
const DEEPLINK_CONVERSION_VALUE = 1.0;
const DEEPLINK_CONVERSION_CURRENCY = 'EUR';

export function initializeGoogleAds(): void {
  try {
    if (!window.gtag) {
      return;
    }
    window.gtag('config', GOOGLE_ADS_ID);
  } catch (error) {
    console.error('Error initializing Google Ads:', error);
  }
}

/**
 * Envoie la conversion Google Ads pour un clic sur le deeplink Appines.
 * Si une URL est fournie, la navigation est différée jusqu'à la réception du
 * callback de conversion (ou au pire 1s plus tard) pour garantir l'envoi.
 */
export function reportAppinesDeeplinkConversion(url?: string): boolean {
  if (!window.gtag) {
    if (url) {
      window.location.href = url;
    }
    return false;
  }

  let navigated = false;
  const navigate = () => {
    if (navigated || !url) return;
    navigated = true;
    window.location.href = url;
  };

  try {
    window.gtag('event', 'conversion', {
      send_to: DEEPLINK_CONVERSION_SEND_TO,
      value: DEEPLINK_CONVERSION_VALUE,
      currency: DEEPLINK_CONVERSION_CURRENCY,
      event_callback: navigate,
    });

    if (url) {
      window.setTimeout(navigate, 1000);
    }
  } catch (error) {
    console.error('Error reporting deeplink conversion:', error);
    navigate();
  }

  return true;
}
